import { render, staticRenderFns } from "./final-list.vue?vue&type=template&id=b20831e4&"
import script from "./final-list.vue?vue&type=script&lang=js&"
export * from "./final-list.vue?vue&type=script&lang=js&"
import style0 from "./final-list.vue?vue&type=style&index=0&id=b20831e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports